// Incident Settings
export const selectIncidentSettingsInitialized = (state) =>
  !state.incidentSettings.loading && state.incidentSettings.settings !== null;
export const selectAllIncidentSettings = (state) =>
  state.incidentSettings.settings;
export const selectIncidentsSortBy = (state) =>
  state.incidentSettings.settings.orderBy;
export const selectIncidentsSortOrder = (state) =>
  state.incidentSettings.settings.order;
export const selectIncidentSettingsLoading = (state) =>
  state.incidentSettings.loading;
